import React from 'react';
export default function Me() {
	return (
		<div>
			<h1>Me</h1>
		</div>
	);
}
